import { Component } from 'sane-ui'
import { gsap } from 'gsap'
import debouce from 'debounce'

class MediaComponent extends Component {
  constructor ($el, args) {
    super($el, args)

    this.isFullWidth = this.$el.is('.media-block--fullwidth')

    if (!this.isFullWidth || !args.bpHelpers.isScreenAtLeast('xl') || (window.sane !== undefined && window.sane.disableMotion)) {
      return
    }

    this.rafID = null // request animation frame id - needed to be able to cancel it on element desctruction.
    this.lastScroll = null

    this.scroll = this.scroll.bind(this)
    this.$inner = this.$el.find('.media-item__inner')
    this.$image = this.$el.find('.media-item__image, .media-item__video')
    this.calcImageBox()
    this.parallaxFactor = 75
    this.raf()

    this.calcImageBox = this.calcImageBox.bind(this)
    this.debouncedCalc = debouce(this.calcImageBox, 200)
    $(window).on('resize', this.debouncedCalc)
  }

  calcImageBox () {
    this.imageHeight = this.$inner.outerHeight()
    this.imageOffset = this.$inner.offset().top
  }

  raf () {
    this.rafID = window.requestAnimationFrame(this.scroll)
  }

  /**
   * Parallax.
   */
  scroll () {
    if (window.app.allowRAF === false) {
      this.raf()
      return
    }

    const scroll = window.pageYOffset * -1

    if (scroll === this.lastScroll) {
      this.raf()
      return
    }

    this.lastScroll = scroll

    let a = ((this.imageOffset - Math.abs(scroll - window.innerHeight)) * -1) / (window.innerHeight + this.imageHeight)

    if (a > 1 || a < 0) {
      this.raf()
      return
    }

    a = Math.max(0, Math.min(1, a)) - 0.5

    const transformObject = { y: `${a * this.parallaxFactor}%` }

    gsap.set(this.$image, transformObject)
    this.raf()
  }

  destroy () {
    $(window).off('resize', this.debouncedCalc)

    if (!this.rafID) {
      return
    }

    window.cancelAnimationFrame(this.rafID)
  }
}

export default MediaComponent



// WEBPACK FOOTER //
// ./scripts/components/MediaComponent.js